<template>
  <div class="content">
    <div class="container-fluid">


      <!-- Date Filter --> 

      <div class="row">

            <div class="col-xl-6 col-md-6">
            

            <!-- <card> -->

                <div class="row">

                  <div class="col-md-6">
                    <label>From</label>
                    <input type="date" class="form-control" id="exampleInputPassword1" v-model="fromDate" @change="Filter()">
                  </div>

                  <div class="col-md-6">
                    <label>To</label>
                    <input type="date" class="form-control" id="exampleInputPassword1" v-model="toDate" @change="Filter()">
                  </div>

<!--                   <div class="col-md-2">
                    <button type="submit" class="seachButton btn btn-primary btn-fill btn-small" @click="GetUsers()">Search</button>
                  </div>  -->

                </div>

            <!-- </card> -->


            </div>

      </div>


          <div class="row">

            <div class="col-md-12 table1">

             <card class="strpied-tabled-with-hover">
              <!-- <card class="card-plain"> -->
                <template slot="header">
                  <h4 class="card-title">Employee Attendance</h4>
                  <!-- <p class="card-category">Here is a subtitle for this table</p> -->
                </template>
                <div class="table-responsive">

                    <table class="table table-hover" id="Attendance">
                      <thead>
                        <slot name="columns"> 
                          <tr>
                            <th v-for="column in columns">{{column}}</th>
                          </tr>
                        </slot>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in List" :key="index">
                          <slot :row="item">
                            <td class="colWidth">{{item.Timestamp | formatDate}}</td>
                            <td class="colWidth">{{item.UserInfo.FirstName}} {{item.UserInfo.LastName}}</td>
                            <td class="colWidth">{{item.LocationInfo.Location}}</td>
                            <td class="colWidth">
                              <span v-if="item.Type == 'CheckIn'" class="CheckIn">IN</span>
                              <span v-if="item.Type == 'CheckOut'" class="CheckOut">OUT</span>
                            </td>
                            <td class="colWidth">{{item.Timestamp | formatDateTime}}</td>
                          </slot>
                        </tr>
                      </tbody>
                    </table>

                </div>
              </card>

            </div>
    
        </div>


    </div>
    </div>
  </div>
</template>
<script>
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import LTable from 'src/components/Table.vue'
  import { globalStore } from '../main.js';
  import { db } from '../main.js';
  import $ from 'jquery';
  import swal from 'sweetalert';
  import moment from 'moment';
  import axios from 'axios';

  import Autocomplete from 'vuejs-auto-complete';
  import VuePhoneNumberInput from 'vue-phone-number-input';
  // Require needed datatables modules
  require('datatables.net')

  // const tableColumns = ['Id', 'Name', 'Salary', 'Country', 'City']
  const tableColumns = ['Photo', 'Name', 'Mobile', 'Email', 'Location', 'Status', 'Requested On', 'Expires On', 'Check Out', 'Created On','Last Updated']
  const tableData = [
  // {
  //   id: 1,
  //   name: 'Dakota Rice',
  //   salary: '$36.738',
  //   country: 'Niger',
  //   city: 'Oud-Turnhout'
  // },
  // {
  //   id: 2,
  //   name: 'Minerva Hooper',
  //   salary: '$23,789',
  //   country: 'Curaçao',
  //   city: 'Sinaai-Waas'
  // },
  // {
  //   id: 3,
  //   name: 'Sage Rodriguez',
  //   salary: '$56,142',
  //   country: 'Netherlands',
  //   city: 'Baileux'
  // },
  // {
  //   id: 4,
  //   name: 'Philip Chaney',
  //   salary: '$38,735',
  //   country: 'Korea, South',
  //   city: 'Overland Park'
  // },
  // {
  //   id: 5,
  //   name: 'Doris Greene',
  //   salary: '$63,542',
  //   country: 'Malawi',
  //   city: 'Feldkirchen in Kärnten'
  // }
  ]

  export default {
    components: {
      LTable,
      ChartCard,
      StatsCard,
      Autocomplete,
      VuePhoneNumberInput
    },
    data () {
      return {
        fromDate: "",
        toDate: "",
        // -----Add Team Member -------
        ShowOnlyMobile: true,
        UserExists: false,
        // ---- country code dropdown
        hasLoaderActive: false,
        hasErrorActive: false,
        defaultCountry: 'US', 
        preferredCountries: ['US', 'IN'],
        yourValue: '',
        // --- End of country code ------
        ShowAddForm: false,
        ShowEditForm: false,
        ShowTable: true, 
        ShowCheckList: true,
        CompanyId: '',
        List: [],
        Locations: [],
        TeamType: [
          {name: "One Time Access", id: "123123", val: "Single"},
          {name: "Multiple Access", id: "989879", val: "Multiple"},
        ],
        columns: [
          'Date',
          'Name',
          'Location',          
          'Type',
          'Timestamp'
        ],
        user: {
          MobileTemp: '',
          Mobile: ''
        },
        FormInfo: {}
      }
    },
    beforeMount(){
      console.log("beforeMount");
    },
    mounted(){
      console.log("Mounted");

      this.CompanyId = globalStore.AdminId
      console.log("CompanyId: "+this.CompanyId);


      this.FirstLoad();


    },
    methods:{
      FirstLoad(){

        console.log("---- First Load ----");


        this.fromDate =  moment().format('YYYY-MM-DD');
        this.toDate = moment().add(1,'days').format('YYYY-MM-DD');

        console.log("From: "+this.fromDate);
        console.log("To: "+this.toDate);


        var CurrentDate = moment().format('YYYY-MM-DD');
        var tomorrow = moment().add(1,'days').format('YYYY-MM-DD');

        console.log("Today: "+CurrentDate);
        console.log("Tomorrow: "+tomorrow);

        this.GetAttendance(CurrentDate, tomorrow);

      },
      Filter(){


        var from = moment(this.fromDate).format('YYYY-MM-DD');
        var to = moment(this.toDate).format('YYYY-MM-DD');

        console.log("From: "+from);
        console.log("To: "+to);

        this.GetAttendance(from, to);

      },      
    GetAttendance(from, to){

      $('#Attendance').DataTable().destroy();
      console.log('Get Attendance called...');

      //-------- fetch all users -------
      this.List = []

      db.collection('Attendance')
        .where('CompanyId','==',this.CompanyId)
        .where("Timestamp", ">", from)
        .where("Timestamp", "<", to)
        .orderBy('Timestamp', 'asc')
        .get()
        .then((snap) => {

          // let data = snap.docs;
          // console.log(data);
          snap.docs.forEach(doc => {
            // console.log("Doc is: " + doc.id);
            // console.log("Name is: " + doc.data().Name);


            this.List.push({
              id: doc.id,
              UserId: doc.data().UserId,
              UserInfo: doc.data().UserInfo,
              LocationInfo: doc.data().LocationInfo,
              LocationId: doc.data().LocationId,
              CompanyId: doc.data().CompanyId,
              CompanyName: doc.data().CompanyName,
              Type: doc.data().Type,
              Timestamp: doc.data().Timestamp,
            });
          });

          setTimeout(()=>{
            console.log('Attendance Logs: ',this.List.length);
            this.initializeDataTable();
          },1000)

        })
        .catch((e) => {

          console.log('Error:', (e));

        });

    },
    notifyVue (verticalAlign, horizontalAlign, msg, type, icon) {
        // const color = Math.floor((Math.random() * 4) + 1)
        this.$notifications.notify(
          {
            message: msg,
            icon: icon,
            horizontalAlign: horizontalAlign,
            verticalAlign: verticalAlign,
            type: type
          })
    },  
    SendWelcomeEmail(val){

                var type = "";
                var date = moment(val.ExpiresOn).format('D MMM YYYY');

                if(val.AccessType == 'Single'){
                  type = "One Time Access";
                }else{
                  type = "Unlimited Access";
                }

                var msg = "Hi "+val.FirstName+",<br><br>"+val.CompanyName+" has added you to their team on Visity for contactless employee check-in. You now have <b>"+type+"</b> access to "+val.CompanyName+" and your access exipres on <b>"+date+"</b>. Click Here to download Visity - http://onelink.to/gkq4am.<br><br>Have a great day!<br>Team Visity";

                  var info = {
                    Email: val.Email,
                    Subject: "Welcome to Visity",
                    Message: msg
                  };

                  console.log("Email Payload: "+JSON.stringify(info, null, 2));
     
                      // // Send Verification via Email
                      axios.post("https://us-central1-visity-usa.cloudfunctions.net/widgets/send-email", info).then((res) => {
                        console.log(res);
                        var response = res;
                      }).catch((e) => {
                        console.log(e);
                      });

    },
      initializeDataTable(){
        console.log("initializeDataTabl")

        setTimeout(() => {
          this.$nextTick(() => {

            $("#Attendance").DataTable({
              // sDom: '<"top"f>rt<"bottom"i><"clear">',
              dom: 'frBtip',
              fixedHeader: true,
              buttons: [
                {
                  extend: "csvHtml5",
                  text: "EXPORT",
                  title: "Employee_Attendance"
                }
              ]
            });

          });
        }, 100);


      },           
    }
  }
</script>
<style scoped="">

  .stats{
    border: 1px solid #DCDCDC;
    border-radius: 0.5em;
  }

  .Label{
    color: #707070;
  }

  .table1{
    margin-top: 1em;
  }

.dt-button.buttons-csv.buttons-html5{
  margin-left: 20em;
  background: #00b33c;
  border: 1px solid #00b33c;
  color: #ffffff;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  padding-left: 1em;
  padding-right: 1em;
  border-radius: 0.5em;
}

#Visitors_filter.dataTables_filter{
    /*margin-left: 5em;*/
  }

  .nc-check-2{
    color: green;
  }

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}

.Hide{
  cursor: pointer;
}

.modal{
  z-index: 5;
}

.CheckIn{
  color: green;
  font-weight: bold;
  font-size: 1em;
}

.CheckOut{
  color: red;
  font-weight: bold;
  font-size: 1em;
}

.colWidth{
  width: 10em;
}

</style>
